import { defineComponent } from 'vue';
import close from '@/assets/images/icon_pic_close.png';
import welcome from '@/assets/images/welcome.jpg';
import { Modal } from 'ant-design-vue';
import { ref } from 'vue';

import './index.less';

export default defineComponent({
  name: 'Welcome',
  props: {
    close: {
      type: Function,
      default: () => {}
    }
  },

  setup(props) {
    return () => (
      <div class="first-login-welcome">
        <div class="first-login-welcome-img">
          <img src={welcome} alt="欢迎访问" />
          <img
            src={close}
            alt="关闭"
            class="first-login-welcome-close"
            onClick={() => {
              props.close();
            }}
          />
        </div>
      </div>
    );
  }
});
